module.exports = __webpack_public_path__ + "static/products-page-bg.a2d5bc13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products-page-bg.jpg
// module id = 1508
// module chunks = 168707334958949